import { memo, useEffect, useState } from 'react';
import { motion, useMotionValue, useTransform, useVelocity, animate } from 'framer-motion';
import { makeSpinEase, SPIN_TAIL } from './stageConfig';

const DIGITS = '01234567890123456789'.split('');

export const StageReel = memo(function StageReel({
  index,
  box,
  target,
  spinKey,
  duration = 40,
  startAt = 0,
  onSettled,
}) {
  const p = useMotionValue(0);
  const [settled, setSettled] = useState(true);
  const itemH = box.h;
  const cycleH = itemH * 10;
  const y = useTransform(p, (v) => -(v % cycleH));
  const vel = useVelocity(p);
  const filter = useTransform(vel, [0, 700, 4200], ['blur(0px)', 'blur(0px)', 'blur(2.5px)']);

  useEffect(() => {
    if (spinKey || target == null) return;
    p.set(target * itemH);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [spinKey, target]);

  const isStatic = !spinKey && target != null;

  useEffect(() => {
    if (!spinKey || target == null) return undefined;
    p.set(0);
    setSettled(false);
    const fast = 6;
    const cycles = Math.round(2.4 * (fast + (duration - fast) * SPIN_TAIL));
    const total = (cycles * 10 + target) * itemH;
    const controls = animate(p, total, {
      duration,
      ease: makeSpinEase(duration, duration - fast),
      onComplete: () => {
        setSettled(true);
        onSettled?.(index);
      },
    });
    if (startAt > 0) controls.time = Math.min(startAt, duration);
    return () => controls.stop();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [spinKey]);

  return (
    <div
      className="absolute overflow-hidden rounded-[6px] bg-white"
      style={{ left: box.x, top: box.y, width: box.w, height: box.h }}
      data-testid={`stage-reel-${index}`}
    >
      <motion.div style={{ y: isStatic ? -(target * itemH) : y, filter, willChange: 'transform' }}>
        {DIGITS.map((d, i) => (
          <div
            key={i}
            className="flex items-center justify-center font-display"
            style={{
              height: itemH,
              fontSize: itemH * 0.62,
              color: settled && target != null && i % 10 === target ? '#0B3D1E' : '#111111',
            }}
          >
            {d}
          </div>
        ))}
      </motion.div>
    </div>
  );
});
